import { render, staticRenderFns } from "./AirportList.vue?vue&type=template&id=5d18b0b8&"
import script from "./AirportList.vue?vue&type=script&lang=js&"
export * from "./AirportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports